/**
 * Generated from ch8_p02.fla
 */
export function ch8_p02(this: Ich8_p02) {
	const bg = this.bg;
	ch8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const holly = this.holly;
	ch8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_holly.call(this.holly);
	holly.x = 738.25;
	holly.y = 689;
	holly.width = 381.50;
	holly.height = 660.00;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const grass = this.grass;
	ch8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_grass.call(this.grass);
	grass.x = 857;
	grass.y = 683;
	grass.width = 1546.00;
	grass.height = 170.00;
	grass.alpha = 1.00;
	if (grass.onLayout) grass.onLayout();
	const speedlines = this.speedlines;
	ch8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_speedlines.call(this.speedlines);
	speedlines.x = 832;
	speedlines.y = 384;
	speedlines.width = 1664.00;
	speedlines.height = 768.00;
	speedlines.alpha = 1.00;
	if (speedlines.onLayout) speedlines.onLayout();
	const frameRight = this.frameRight;
	ch8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 351.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const linesRight = this.linesRight;
	ch8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_wcframeR.call(this.linesRight);
	linesRight.x = 1664;
	linesRight.y = 223.25;
	linesRight.width = 124.00;
	linesRight.height = 446.50;
	linesRight.alpha = 1.00;
	if (linesRight.onLayout) linesRight.onLayout();
	const frameLeft = this.frameLeft;
	ch8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 345.50;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesLeft = this.linesLeft;
	ch8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_wcframeL.call(this.linesLeft);
	linesLeft.x = 0;
	linesLeft.y = 534.75;
	linesLeft.width = 106.00;
	linesLeft.height = 115.50;
	linesLeft.alpha = 1.00;
	if (linesLeft.onLayout) linesLeft.onLayout();
	return this;
}
function ch8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_bg(this: Ich8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p02_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_holly(this: Ich8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p02_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_grass(this: Ich8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_grass) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p02_grass", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_speedlines(this: Ich8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_speedlines) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp8_p02_speedlines", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_wcframeRframe(this: Ich8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_wcframeR(this: Ich8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_wcframeR) {
	if (this.setLayoutTexture) this.setLayoutTexture("R", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("multiply");
	return this;
}
function ch8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_wcframeLframe(this: Ich8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_wcframeL(this: Ich8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_wcframeL) {
	if (this.setLayoutTexture) this.setLayoutTexture("L", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich8_p02Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich8_p02Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich8_p02Sprite extends Ich8_p02Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich8_p02Text extends Ich8_p02Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich8_p02Polygon extends Array<number> {
}
interface Ich8_p02 {
	readonly bg: Ich8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_bg;
	readonly holly: Ich8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_holly;
	readonly grass: Ich8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_grass;
	readonly speedlines: Ich8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_speedlines;
	readonly frameRight: Ich8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_wcframeRframe;
	readonly linesRight: Ich8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_wcframeR;
	readonly frameLeft: Ich8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_wcframeLframe;
	readonly linesLeft: Ich8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_wcframeL;
}
interface Ich8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_bg extends Ich8_p02Sprite {
}
interface Ich8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_holly extends Ich8_p02Sprite {
}
interface Ich8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_grass extends Ich8_p02Sprite {
}
interface Ich8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_speedlines extends Ich8_p02Sprite {
}
interface Ich8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_wcframeRframe extends Ich8_p02Sprite {
}
interface Ich8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_wcframeR extends Ich8_p02Sprite {
}
interface Ich8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_wcframeLframe extends Ich8_p02Sprite {
}
interface Ich8_p02_hh_ch8_72dpi_p02psdAssetchp8_p02_wcframeL extends Ich8_p02Sprite {
}
